import { EPercentIsEmpty } from '../../enum'

// Create a union type of all possible values from the enum
type IPercentIsEmptyLangKey = `${EPercentIsEmpty}`

export type IPercentIsEmptyLang = {
	percent_is_empty: Record<IPercentIsEmptyLangKey, string>
}

const langEntries = Object.entries(EPercentIsEmpty).map(
	([key, value]) => [value, `percent_is_empty.${value}`]
)

const langObj: Record<IPercentIsEmptyLangKey, string> = Object.fromEntries(langEntries)

export const PERCENT_IS_EMPTY_LANG_KEY: IPercentIsEmptyLang = {
	percent_is_empty: langObj
}
